"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genericRoleDefsByCode = exports.mergePermissionsFromRoleDefs = exports.genericFullAccess = exports.genericGraphicLeadRoleDef = exports.genericGraphicRoleDef = exports.genericOrgOwnerRoleDef = exports.genericOrgAdminRoleDef = exports.genericStandardUserRoleDef = exports.genericNotAuthRoleDef = void 0;
/* eslint-disable no-unused-vars */
const EPermissioData_1 = require("../../../core/domain/EPermissioData");
const EPermissionUi_1 = require("../../../core/domain/EPermissionUi");
const { UI_READ, UI_ADMIN, UI_WRITE, UI_DELETE, UI_READ_ORG, UI_WRITE_ORG, UI_READ_ALL, UI_WRITE_ALL, UI_SHARE, UI_CUSTOMIZE, UI_MASTER_ADMIN, } = EPermissionUi_1.EPermissionUi.V;
const { D_READ, D_WRITE, D_WRITE_ALL, D_READ_ALL, D_WRITE_ORG, D_READ_ORG } = EPermissioData_1.EPermissionData.V;
function add(perms) {
    return perms.reduce((res, permVal) => {
        res[permVal] = true;
        return res;
    }, {});
}
exports.genericNotAuthRoleDef = {
    key: "GNA",
    name: "Not Authenticated",
    description: "",
    labels: ["CLIENT", "PORTAL", "APP"],
    rootDbPermissions: {},
    rootStoragePermissions: {},
    portalUiPermissions: {
        urlSignup: add([UI_READ, UI_WRITE]),
        urlLogin: add([UI_READ, UI_WRITE]),
        urlSupportTicket: add([UI_READ, UI_WRITE]),
        urlSalesOfferings: add([UI_READ]),
        urlResetPassword: add([UI_READ, UI_WRITE]),
        menuPublic: add([UI_READ]),
    },
    appUiPermissions: {
        public: add([UI_READ]),
    },
};
exports.genericStandardUserRoleDef = {
    key: "GSU",
    name: "Standard User",
    description: "",
    labels: ["CLIENT", "PORTAL", "APP"],
    rootDbPermissions: {
        PRJ: add([D_READ, D_WRITE]),
        USR: add([D_READ, D_WRITE]),
        TSK: add([D_READ, D_WRITE]),
    },
    rootStoragePermissions: {
        MV: add([D_READ, D_WRITE]),
        AI: add([D_READ, D_WRITE]),
    },
    portalUiPermissions: {
        urlUser: add([UI_READ, UI_WRITE]),
        urlInfoImprint: add([UI_READ]),
        urlInfoTerms: add([UI_READ]),
        urlInfoCookies: add([UI_READ]),
        urlInfoData: add([UI_READ]),
        urlAccountMessages: add([UI_READ, UI_WRITE]),
        urlSignup: add([UI_READ, UI_WRITE]),
        urlTask: add([UI_READ]),
        urlLogin: add([UI_READ, UI_WRITE]),
        urlBackendTest: add([UI_READ]),
        urlQueue: add([UI_READ]),
        urlModel: add([UI_READ, UI_WRITE]),
        urlUpload: add([UI_READ, UI_WRITE]),
        urlUserModels: add([UI_READ]),
        urlSupportTicket: add([UI_READ, UI_WRITE]),
        urlTutorials: add([UI_READ]),
        urlSalesOfferings: add([UI_READ]),
        urlResetPassword: add([UI_READ, UI_WRITE]),
        urlUserDashboard: add([UI_READ]),
        menuPublic: add([UI_READ]),
        menuStandard: add([UI_READ]),
    },
    appUiPermissions: {
        public: add([UI_READ]),
        standard: add([UI_READ, UI_WRITE]),
    },
};
exports.genericOrgAdminRoleDef = {
    key: "GOA",
    name: "Organization Admin",
    description: "",
    labels: ["CLIENT", "ORG_ADMIN", "PORTAL", "APP"],
    rootDbPermissions: {
        PRJ: add([D_READ_ORG, D_WRITE_ORG]),
        USR: add([D_READ_ORG, D_WRITE_ORG]),
        TSK: add([D_READ_ORG, D_WRITE_ORG]),
    },
    rootStoragePermissions: {
        MV: add([D_READ_ORG, D_WRITE_ORG]),
        AI: add([D_READ_ORG, D_WRITE_ORG]),
    },
    portalUiPermissions: {
        urlUser: add([UI_READ, UI_WRITE]),
        urlAccountBilling: add([UI_READ, UI_WRITE]),
        urlAccountProposals: add([UI_READ, UI_WRITE]),
        urlInfoImprint: add([UI_READ]),
        urlInfoTerms: add([UI_READ]),
        urlOrgAdmin: add([UI_READ, UI_WRITE, UI_DELETE]),
        urlInfoCookies: add([UI_READ]),
        urlInfoData: add([UI_READ]),
        urlCompanySettings: add([UI_READ, UI_WRITE]),
        urlSignup: add([UI_READ, UI_WRITE]),
        urlTask: add([UI_READ]),
        urlLogin: add([UI_READ, UI_WRITE]),
        urlModel: add([UI_READ, UI_WRITE]),
        urlUpload: add([UI_READ, UI_WRITE]),
        urlUserModels: add([UI_READ]),
        urlSupportTicket: add([UI_READ, UI_WRITE]),
        urlTutorials: add([UI_READ]),
        urlSalesOfferings: add([UI_READ]),
        urlResetPassword: add([UI_READ, UI_WRITE]),
        urlUserDashboard: add([UI_READ]),
        menuPublic: add([UI_READ]),
        menuStandard: add([UI_READ]),
        menuOrgAdmin: add([UI_READ]),
    },
    appUiPermissions: {
        public: add([UI_READ]),
        standard: add([UI_READ, UI_WRITE]),
        orgAdmin: add([UI_READ, UI_WRITE]),
    },
};
exports.genericOrgOwnerRoleDef = {
    key: "GOO",
    name: "Organization Owner",
    description: "",
    labels: ["CLIENT", "ORG_ADMIN", "UNIT_ADMIN", "ACCOUNT_ADMIN", "OWNER", "PORTAL", "APP"],
    rootDbPermissions: {
        ACT: add([D_READ_ORG, D_WRITE_ORG]),
        PRJ: add([D_READ_ORG, D_WRITE_ORG]),
        USR: add([D_READ_ORG, D_WRITE_ORG]),
        TSK: add([D_READ_ORG, D_WRITE_ORG]),
    },
    rootStoragePermissions: {
        MV: add([D_READ_ORG, D_WRITE_ORG]),
        AI: add([D_READ_ORG, D_WRITE_ORG]),
    },
    portalUiPermissions: {
        urlUser: add([UI_READ, UI_WRITE]),
        urlAccountBilling: add([UI_READ, UI_WRITE]),
        urlAccountProposals: add([UI_READ, UI_WRITE]),
        urlInfoImprint: add([UI_READ]),
        urlInfoTerms: add([UI_READ]),
        urlInfoCookies: add([UI_READ]),
        urlInfoData: add([UI_READ]),
        urlCompanySettings: add([UI_READ, UI_WRITE]),
        urlSignup: add([UI_READ, UI_WRITE]),
        urlOrgAdmin: add([UI_READ, UI_WRITE, UI_ADMIN, UI_DELETE]),
        urlLogin: add([UI_READ, UI_WRITE]),
        urlModel: add([UI_READ, UI_WRITE, UI_READ_ORG, UI_WRITE_ORG]),
        urlUpload: add([UI_READ, UI_WRITE]),
        urlUserModels: add([UI_READ]),
        urlSupportTicket: add([UI_READ, UI_WRITE]),
        urlTutorials: add([UI_READ]),
        urlSalesOfferings: add([UI_READ]),
        urlResetPassword: add([UI_READ, UI_WRITE]),
        urlUserDashboard: add([UI_READ]),
        menuPublic: add([UI_READ]),
        menuStandard: add([UI_READ]),
        menuOrgAdmin: add([UI_READ]),
        orgOwner: add([UI_ADMIN]),
    },
    appUiPermissions: {
        public: add([UI_READ]),
        standard: add([UI_READ, UI_WRITE]),
        orgAdmin: add([UI_READ, UI_WRITE, UI_ADMIN, UI_DELETE]),
        orgOwner: add([UI_READ, UI_WRITE, UI_ADMIN, UI_DELETE]),
    },
};
exports.genericGraphicRoleDef = {
    key: "GGR",
    name: "Graphic",
    description: "Generic graphic role.",
    labels: ["PORTAL", "APP", "SUPPORT", "GRAPHIC"],
    rootDbPermissions: {
        PRJ: add([D_WRITE_ALL, D_READ_ALL]),
        USR: add([D_WRITE_ALL, D_READ_ALL]),
        TSK: add([D_WRITE_ALL, D_READ_ALL]),
        STU: add([D_WRITE_ALL, D_READ_ALL]),
    },
    rootStoragePermissions: {
        MV: add([D_WRITE_ALL, D_READ_ALL]),
        AI: add([D_WRITE_ALL, D_READ_ALL]),
    },
    portalUiPermissions: {
        urlUser: add([UI_READ, UI_WRITE]),
        urlAccountProposals: add([UI_READ]),
        urlInfoImprint: add([UI_READ]),
        urlInfoTerms: add([UI_READ]),
        urlInfoCookies: add([UI_READ]),
        urlInfoData: add([UI_READ]),
        urlSignup: add([UI_READ, UI_WRITE]),
        urlTask: add([UI_READ, UI_WRITE]),
        urlLogin: add([UI_READ, UI_WRITE]),
        urlModel: add([UI_READ, UI_WRITE, UI_READ_ALL]),
        urlUpload: add([UI_READ, UI_WRITE]),
        urlUserModels: add([UI_READ]),
        urlSupportTicket: add([UI_READ, UI_WRITE]),
        urlTutorials: add([UI_READ]),
        urlSalesOfferings: add([UI_READ]),
        urlResetPassword: add([UI_READ]),
        urlUserDashboard: add([UI_READ]),
        menuPublic: add([UI_READ]),
        menuStandard: add([UI_READ]),
        menuGraphic: add([UI_READ]),
    },
    appUiPermissions: {
        public: add([UI_READ]),
        standard: add([UI_READ, UI_WRITE]),
        graphic: add([UI_READ, UI_WRITE]),
    },
};
exports.genericGraphicLeadRoleDef = {
    key: "GGL",
    name: "Graphic Lead",
    description: "Generic graphic lead role.",
    labels: ["PORTAL", "APP", "LEAD", "SUPPORT", "GRAPHIC"],
    rootDbPermissions: {
        PRJ: add([D_WRITE_ALL, D_READ_ALL]),
        USR: add([D_WRITE_ALL, D_READ_ALL]),
        TSK: add([D_WRITE_ALL, D_READ_ALL]),
        STU: add([D_WRITE_ALL, D_READ_ALL]),
    },
    rootStoragePermissions: {
        MV: add([D_WRITE_ALL, D_READ_ALL]),
        AI: add([D_WRITE_ALL, D_READ_ALL]),
    },
    portalUiPermissions: {
        urlUser: add([UI_READ, UI_WRITE]),
        urlAccountProposals: add([UI_READ]),
        urlInfoImprint: add([UI_READ]),
        urlInfoTerms: add([UI_READ]),
        urlInfoCookies: add([UI_READ]),
        urlInfoData: add([UI_READ]),
        urlSignup: add([UI_READ, UI_WRITE]),
        urlTask: add([UI_READ, UI_WRITE, UI_DELETE]),
        urlLogin: add([UI_READ, UI_WRITE]),
        urlModel: add([UI_READ, UI_WRITE, UI_READ_ALL, UI_WRITE_ALL]),
        urlUpload: add([UI_READ, UI_WRITE]),
        urlUserModels: add([UI_READ]),
        urlSupportTicket: add([UI_READ, UI_WRITE]),
        urlTutorials: add([UI_READ]),
        urlSalesOfferings: add([UI_READ]),
        urlResetPassword: add([UI_READ]),
        urlUserDashboard: add([UI_READ]),
        menuPublic: add([UI_READ]),
        menuStandard: add([UI_READ]),
        menuGraphic: add([UI_READ]),
        menuLeadGraphic: add([UI_READ]),
    },
    appUiPermissions: {
        public: add([UI_READ]),
        standard: add([UI_READ, UI_WRITE]),
        graphic: add([UI_READ, UI_WRITE]),
        leadGraphic: add([UI_READ, UI_WRITE]),
    },
};
exports.genericFullAccess = {
    key: "GFA",
    name: "Full access",
    description: "Full access to all UI elements, DB and Storage actions",
    labels: ["SUPPORT", "PORTAL", "APP", "FULL_ACCESS"],
    rootDbPermissions: {
        PRJ: add([D_WRITE_ALL, D_READ_ALL]),
        ACT: add([D_WRITE_ALL, D_READ_ALL]),
        DBM: add([D_WRITE_ALL, D_READ_ALL]),
        GWK: add([D_WRITE_ALL, D_READ_ALL]),
        STU: add([D_WRITE_ALL, D_READ_ALL]),
        USR: add([D_WRITE_ALL, D_READ_ALL]),
        TSK: add([D_WRITE_ALL, D_READ_ALL]),
    },
    rootStoragePermissions: {
        MV: add([D_WRITE_ALL, D_READ_ALL]),
        AI: add([D_WRITE_ALL, D_READ_ALL]),
    },
    portalUiPermissions: {
        urlUser: add([UI_READ, UI_ADMIN]),
        urlAccountProposals: add([UI_READ, UI_ADMIN]),
        urlInfoImprint: add([UI_READ, UI_ADMIN]),
        urlInfoTerms: add([UI_READ, UI_ADMIN]),
        urlInfoCookies: add([UI_READ, UI_ADMIN]),
        urlInfoData: add([UI_READ, UI_ADMIN]),
        urlSignup: add([UI_READ, UI_WRITE, UI_ADMIN]),
        urlTask: add([UI_READ, UI_WRITE, UI_ADMIN, UI_DELETE]),
        urlLogin: add([UI_READ, UI_WRITE, UI_ADMIN]),
        urlModel: add([UI_READ, UI_WRITE, UI_ADMIN, UI_READ_ALL, UI_WRITE_ALL]),
        urlUpload: add([UI_READ, UI_WRITE, UI_ADMIN]),
        urlUserModels: add([UI_READ, UI_ADMIN]),
        urlSupportTicket: add([UI_READ, UI_WRITE, UI_ADMIN]),
        urlTutorials: add([UI_READ, UI_WRITE, UI_ADMIN]),
        urlSalesOfferings: add([UI_READ, UI_WRITE, UI_ADMIN]),
        urlResetPassword: add([UI_READ, UI_WRITE, UI_ADMIN]),
        urlUserDashboard: add([UI_READ, UI_ADMIN]),
        urlAdmin: add([UI_READ, UI_WRITE, UI_ADMIN]),
        menuPublic: add([UI_READ, UI_ADMIN]),
        menuStandard: add([UI_READ, UI_ADMIN]),
        menuGraphic: add([UI_READ, UI_ADMIN]),
        menuLeadGraphic: add([UI_READ, UI_ADMIN]),
        menuOrgAdmin: add([UI_READ, UI_ADMIN]),
        orgOwner: add([UI_READ, UI_WRITE, UI_ADMIN, UI_DELETE]),
        masterAdmin: add([UI_READ, UI_WRITE, UI_ADMIN, UI_DELETE]),
    },
    appUiPermissions: {
        public: add([UI_READ]),
        standard: add([UI_READ, UI_WRITE]),
        graphic: add([UI_READ, UI_WRITE]),
        leadGraphic: add([UI_READ, UI_WRITE]),
        orgAdmin: add([UI_READ, UI_WRITE]),
        orgOwner: add([UI_READ, UI_WRITE, UI_ADMIN, UI_DELETE]),
        masterAdmin: add([UI_READ, UI_WRITE, UI_ADMIN, UI_DELETE]),
    },
};
function mergePermissionsFromRoleDefs(roles) {
    const resPerms = {
        appUiPermissions: {},
        portalUiPermissions: {},
        rootDbPermissions: {},
        rootStoragePermissions: {},
    };
    return roles.reduce((resP, role) => {
        Object.entries(resP).forEach(([permType, resPerms]) => {
            for (const [permKey, permObj] of Object.entries(role[permType])) {
                resPerms[permKey] = { ...resPerms[permKey], ...permObj };
            }
        });
        return resP;
    }, resPerms);
}
exports.mergePermissionsFromRoleDefs = mergePermissionsFromRoleDefs;
exports.genericRoleDefsByCode = {
    GNA: exports.genericNotAuthRoleDef,
    GSU: exports.genericStandardUserRoleDef,
    GOA: exports.genericOrgAdminRoleDef,
    GOO: exports.genericOrgOwnerRoleDef,
    GGR: exports.genericGraphicRoleDef,
    GGL: exports.genericGraphicLeadRoleDef,
    GFA: exports.genericFullAccess,
};
//# sourceMappingURL=genericRoleDefs.js.map